import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";

import SuiAlert from "components/SoftAlert";
import { useSnackbar } from "providers/SnackbarProvider";

// import the hook instead of static data
import useAuthorsTableData from "layouts/stores/data/storesTableData";
import { AddRounded, WarningRounded } from "@mui/icons-material";
import { Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions } from "@mui/material";
import SoftButton from "components/SoftButton";
import React, { useState } from "react";
import SoftInput from "components/SoftInput";

const apiUrl = "https://api.getverceipt.com/api/v1";

function Tables() {
  // call the hook here
  const { columns, rows, loading, storeCount, maxStores, refetch, editDialog } = useAuthorsTableData();
  const [open, setOpen] = useState(false);
  const [storeName, setStoreName] = useState("");
  const [storeAddrError, setStoreAddrError] = useState(false);

  const { showSnackbar } = useSnackbar();

  const handleSubmit = async () => {
    // basic checks
    if (storeName.length > 3) {
      try {
        const response = await fetch(`${apiUrl}/business/store/create`, {
          method: 'POST',
          withCredentials: true,
          credentials: 'include', // make sure cookies/session are sent
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ address: storeName })
        });        
        if (!response.ok) throw new Error("Network response was not ok");

        console.log("Store added:", storeName);
        setOpen(false);
        setStoreName("");

        showSnackbar("Successfully created a new store!", "success");
        setStoreAddrError(false);
        refetch();
      }
      catch (error) {
        showSnackbar(`An error occurred: ${error}`, "error");
        setStoreAddrError(true);
      }
    } else {
        showSnackbar(`Store names must be at least 3 characters in length.`, "error");
        setStoreAddrError(true);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <>
        {storeCount >= maxStores * 0.75 &&
        <SuiAlert color="warning">
          <WarningRounded/> You have used the majority of your store allocation. Upgrade to get more.
        </SuiAlert>
        }
        </>

        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6">Your stores ({storeCount} / {maxStores})</SoftTypography>
              <SoftButton variant="contained" color="info" onClick={() => setOpen(true)} disabled={storeCount >= maxStores}><AddRounded/> Add new store</SoftButton>
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <SoftTypography p={3} variant="body2">
                  Loading team...
                </SoftTypography>
              ) : (
                <Table columns={columns} rows={rows} />
              )}
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Add a new store</DialogTitle>
        <DialogContent>
          <SoftInput
            autoFocus
            margin="dense"
            placeholder="Enter new store address here.."
            type="text"
            fullWidth
            value={storeName}
            error={storeAddrError}
            onChange={(e) => setStoreName(e.target.value)}
          />
          {/* add more fields here */}
        </DialogContent>
        <DialogActions>
          <SoftButton onClick={() => setOpen(false)} color="error">Cancel</SoftButton>
          <SoftButton variant="contained" color="success" onClick={handleSubmit}>
            Add
          </SoftButton>
        </DialogActions>
      </Dialog>
      {editDialog}
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
